<template>
  <section class="erro">
    <div class="container">
      <div class="box">
        <div class="row">
          <div class="col-12">
            <div class="num-erro d-flex align-items-center justify-content-center">
              <i class="fas fa-exclamation-triangle mr-2"></i>
              <p>404</p>
            </div>
          </div>
          <div class="col-12 col-md-6 text-center">
            <img :src="require('@/assets/img/source.gif')" alt="Erro 404" class="img-fluid mb-3" />
          </div>
          <div class="col-12 col-md-6 text-center text-md-left erro-msg">
            <p>Ops!</p>
            <p>Seu paciente teve alta!</p>
            <p>A página que você tentou acessar não existe, ou o link que você usou está com algum erro. </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PaginaNaoEncontradaView',

  data () {
    return {
      termoPesquisa: ''
    }
  },

  mounted () {
    this.termoPesquisa = this.$route.query.q
  },

  methods: {
    buscaGeralPlataforma: function () {
      this.$store.dispatch('buscaGeralPlataforma', this.termoPesquisa)
      this.$router.push(`/busca?q=${this.termoPesquisa}`)
    }
  }
}
</script>

<style scoped>

</style>
